var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('system-bar'),_c('app-bar'),_c('v-navigation-drawer',{attrs:{"app":"","color":"#1f2428","width":"300","permanent":""}},[_c('navigation-drawer'),_c('side-bar')],1),_c('main-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }